<script>
import Endpoints from '../../../components/common/Endpoints';
import Common from '../../../components/common/Common';
import Request from '../../../components/common/Request';

let type = "SERVICE";

export default {
    init: async (payload) => {
        const el = document.body;
        el.removeAttribute("class");
        $('.modal').modal('hide');
        $('#spinner').modal('toggle');

        setTimeout(async function(){
            let query = {
                type: type
            };
            let response = (await Request.do(payload, 'GET', Request.getDefaultHeader(payload), {}, `${Endpoints.systemUsers.getMe}`)).data;
            if (response.status==200){
                payload.user = response.result;

                payload.data.serviceFamilies = response.result.companyUser.company.serviceFamilies;
                
                let responseFamilies = await Request.do(payload, 'POST', Request.getDefaultHeader(payload), query, `${Endpoints.parts.families.listByType}`);
                payload.families = responseFamilies.data.results;
            }
            $('#spinner').modal('toggle');
        }, 100);
    },
    methods:{
        save: function(){
            $('#spinner').modal('toggle');
            this.errors = [];
            this.messageIdToast = null;
            let state = this;

            console.log(this.data.document);
            this.data.document = this.data.document.replace(/\//g, '').replace(/\./g, '').replace(/\-/g, '');
            console.log(this.data.document);
            Request.do(this, 'PUT', Request.getDefaultHeader(this), this.data, `${Endpoints.companies.perfil}${this.data.document}`,
                (companyResponse)=>{//SUCCESS CALLBACK
                    $('#spinner').modal('toggle');
                    this.flashMessage.success(
                            this.configMessage(this.$t('string.msg.perfilTruckService.register.title.success'), this.$t('string.msg.perfilTruckService.register.message.success'), 'top left', 3000),
                        {
                            mounted: this.showText(this.$t('string.msg.perfilTrperfilTruckServiceuck.register.message.success')),
                            destroyed: this.clearText()
                        }) 
                },
                (error)=>{//ERROR CALLBACK
                    $('#spinner').modal('toggle');
                    let res = error.response;
                    if (res && res.status){
                        this.titleToast = this.$t("string.msg.warning");
                        if (res.data.messageId === 'response.msg.error.empty.fields'){
                            let fields = "";
                            res.data.errors.forEach(function (value) {
                                fields += state.$t(value.id)+";<br/>";
                            });
                            this.titleToast = this.$t(res.data.messageId);
                            this.messageToast = this.$t(fields);
                        }else if (res.data.messageId === 'response.already.exists'){
                            this.messageToast = this.$t('response.company.already.exists');
                        }else{
                            this.messageToast = this.$t(res.data.messageId);
                            this.messageIdToast = res.data.messageId;
                        }

                        $('#toast').modal('show');
                    }
                    console.log(JSON.stringify(error));
            });
        },
        selectAll: function(){
            if (!this.isAllSelected){
                let state = this;
                this.data.serviceFamilies = [];
                this.families.forEach(function (item) {
                    if (item && item._id)
                        state.data.serviceFamilies.push(item._id);
                });
                this.isAllSelected = true;
            }else{
                this.data.serviceFamilies = [];
                this.isAllSelected = false;
            }
            
        },
        selectItem: function(item){
            this.data = JSON.parse(JSON.stringify(item));
            
            this.data.fantasyName = Common.camelize(this.data.fantasyName);
            this.data.socialName = Common.camelize(this.data.socialName);
            this.data.document = this.data.document.replace(/\//g, '').replace(/\./g, '').replace(/\-/g, '');
            
            this.data.families = [];
            this.isAllSelected = false;
            
            document.body.scrollTop = 0; // For Safari
            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
        },
        isAdminMaster: function(){
            if (this.user){
                return this.user.companyUser && this.user.companyUser.subtype === "ADMIN_MASTER";
            }
            return false;
        },
        clearForm: function(){
            this.data = null;
        },
        showText(text) {
            this.text = text
        },
        clearText() {
            setTimeout( () => this.text = '', 500);
        },
        configMessage :function(title, message, position, time){
            const config ={
               title: title,
                message: message,
                position: position,
                x: window.innerWidth /60,
                y: window.innerHeight /1.3,
                time: time,
            }
            return config
        },
        camelize: Common.toUpperCase,
    }
}
</script>
